export default "__VITE_ASSET__CVN1CjKk__"